import React, { forwardRef } from "react";
import Box from "@material-ui/core/Box";
import FormLabel from "@material-ui/core/FormLabel";
import NmLogo from "./nm_logo.png";
import { Typography } from "@mui/material";
import { Other } from "./index";
import moment from "moment";

import Amendment from "./Letters/Amendment";
import Clarification from "./Letters/Clarification";

const lineSpace = "16px";

const AmendmentLetter = forwardRef((props) => {
	const {
		contract,
		applicant,
		street,
		city,
		state,
		zip,
		yourSincerely,
		selectedChangeTypes,
		otherTypeText,
		amendmentType,
		dealStructure,
		recordType,
	} = props;

	return (
		<Box sx={{ position: "sticky", top: "50px" }}>
			{amendmentType !== "New Docs" && <Box mb={2}>
				<FormLabel component="legend">Preview</FormLabel>
			</Box>}
			{amendmentType === "Amendment" ? (
				<Amendment {...props} />
			) : amendmentType === "Clarification Letter" ? (
				<Clarification {...props} />
			) : (
				<Box></Box>
			)}
		</Box>
	);
});

export default AmendmentLetter;
